import { reactive, inject, provide } from 'vue'

export const useInitGridState = () => {
  const gridStateContext = reactive({
    gridApi: null,

    isFiltering: false,
    activeFilters: [],
    resetFilters: undefined,

    isCustomColumns: false,
    resetColumns: undefined,

    isSorting: false,
    activeSort: [],

    needsRefresh: false,
    refresh: undefined,
    seenRowId: null,

    deselectSelectedRow: undefined
  })

  provide('gridStateContext', gridStateContext)

  return { context: gridStateContext }
}

export const useGridState = () => {
  const context = inject('gridStateContext')

  if (!context) {
    throw new Error('No Grid State Provided')
  }

  return {
    context
  }
}
